import React from 'react';

import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonSizes, ActionButtonVariants } from 'components/action-button';
import { LoyaltyPointsButton } from 'components/loyalty-points-button';
import { useGetLoginRoute } from 'hooks/navigation/use-get-login-route';
import { useAuthContext } from 'state/auth';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

const MobileHeaderCta = () => {
  const { formatMessage } = useIntl();

  const enableSignUp = useFlag(LaunchDarklyFlag.ENABLE_SIGN_UP);
  const { isAuthenticated } = useAuthContext();
  const loginRoute = useGetLoginRoute();

  if (isAuthenticated) {
    return (
      <>
        <LoyaltyPointsButton />
      </>
    );
  }

  if (!enableSignUp) {
    return null;
  }

  return (
    <ActionButton
      variant={ActionButtonVariants.PRIMARY}
      size={ActionButtonSizes.SMALL}
      to={loginRoute}
      testID="mobile-nav-signup-link"
      alignSelf="center"
    >
      {formatMessage({ id: 'signInUp' })}
    </ActionButton>
  );
};

export default MobileHeaderCta;
